import type { QualityAssessment, QualityCell, ReviewResult } from './serviceExecutionApi';
import { studyGroups } from './reviewStudies';

export function qualityCellReady(result: ReviewResult, reports: string[], cell: QualityCell) {
  const criterion = result.config.quality?.criteria[cell.criterion - 1];
  if (!criterion || !cell.reason.trim() || cell.insufficient && cell.judgement || !cell.insufficient && (!criterion.answers.includes(cell.judgement) || !cell.evidence.length)) return false;
  return cell.evidence.every((evidence) => reports.includes(evidence.record_id) && evidence.quote.trim() && result.records.some((record) => record.id === evidence.record_id && record.full_text?.some((fragment) => fragment.id === evidence.fragment_id && fragment.text.includes(evidence.quote))));
}

export function qualityAssessmentReady(result: ReviewResult, reports: string[], assessment: QualityAssessment) {
  return assessment.conclusion.trim() && assessment.cells.length === result.config.quality?.criteria.length && new Set(assessment.cells.map((cell) => cell.criterion)).size === assessment.cells.length && assessment.cells.every((cell) => qualityCellReady(result, reports, cell));
}

export function qualityReady(result: ReviewResult) {
  if (!result.config.quality) return !Object.keys(result.quality_assessments || {}).length;
  if (result.config.quality.ai_suggestions && !result.quality_proposed) return false;
  const groups = studyGroups(result);
  if (Object.keys(result.quality_assessments || {}).some((key) => !groups.some((group) => group.id === key))) return false;
  return groups.every((group) => {
    const assessment = Object.prototype.hasOwnProperty.call(result.quality_assessments || {}, group.id) ? result.quality_assessments![group.id] : undefined;
    return assessment?.verified && qualityAssessmentReady(result, group.reports.map((record) => record.id), assessment);
  });
}
